var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .subscription-inactive-1{fill:none;}\n      .subscription-inactive-2{fill:#d2ddfa;}\n      .subscription-inactive-3{fill:#b4c6fa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Nav-Ver01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "subscription-inactive-1",
    d: "M1,23.13H3a2,2,0,0,1-1.32-.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "subscription-inactive-2",
    d: "M6.5,14.13a5.5,5.5,0,0,1,10.3-2.68l5.85-4.32a1.92,1.92,0,0,0-.58-.59l-7.92-5a4,4,0,0,0-4.3,0l-7.92,5A2,2,0,0,0,1,8.23v12.9a2,2,0,0,0,.68,1.49L8,17.93A5.5,5.5,0,0,1,6.5,14.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "subscription-inactive-3",
    d: "M23,21.13V8.23a1.94,1.94,0,0,0-.35-1.1L16.8,11.45A5.5,5.5,0,0,1,8,17.93L1.68,22.62A2,2,0,0,0,3,23.13H21A2,2,0,0,0,23,21.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "subscription-inactive-2",
    d: "M16,13.86a1.11,1.11,0,0,0-1.07-1H13.15V11.22A1.13,1.13,0,0,0,12,10.13h-.12a1.11,1.11,0,0,0-1,1.08v1.62H9.09A1.12,1.12,0,0,0,8,14v.13a1.11,1.11,0,0,0,1.08,1h1.76V17A1.13,1.13,0,0,0,12,18.13h.12a1.11,1.11,0,0,0,1-1.08V15.13h1.76A1.12,1.12,0,0,0,16,14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInactive);
export default __webpack_public_path__ + "static/media/subscription-inactive.c247a340dc041f4bb6ffa5ae533cb61a.svg";
export { ForwardRef as ReactComponent };